import { featuredCase, hotRank } from '@/mocks/home';

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日大瓜热榜</h2>
            <p className="mt-1 text-sm text-foreground-600">按实时热度排序，每 10 分钟刷新一次</p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-refresh-line"></i>
            12 分钟前更新
          </span>
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          <article className="group lg:col-span-2">
            <a href="#feed" className="relative block h-[280px] w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src={featuredCase.cover}
                alt={featuredCase.title}
                title={featuredCase.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="cover-shade absolute inset-0"></div>
              <span className="absolute left-4 top-4 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                {featuredCase.category}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-white md:text-2xl">{featuredCase.title}</h3>
                <p className="mt-2 line-clamp-2 max-w-2xl text-xs leading-relaxed text-background-200 md:text-sm">
                  {featuredCase.desc}
                </p>
                <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-300">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-400"></i>热度 {featuredCase.heat}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {featuredCase.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-star-line"></i>
                    {featuredCase.source}
                  </span>
                </div>
              </div>
            </a>
          </article>

          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
              <span className="text-sm font-medium text-foreground-900">热度排行</span>
              <span className="text-xs text-foreground-500">TOP 5</span>
            </div>
            <ul>
              {hotRank.map((item) => (
                <li key={item.rank}>
                  <a href="#feed" className="flex items-center gap-3 border-b border-background-100 px-4 py-3 last:border-0 hover:bg-background-100">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        item.rank <= 3 ? 'bg-accent-500 text-foreground-950' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <img
                      src={item.thumb}
                      alt={item.title}
                      title={item.title}
                      className="h-11 w-11 shrink-0 rounded-md object-cover object-top"
                    />
                    <span className="min-w-0 flex-1">
                      <span className="line-clamp-2 block text-sm leading-snug text-foreground-900">{item.title}</span>
                      <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{item.tag}</span>
                        {item.heat}
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}